import CUSTOMERS from './items/customers.menu'
import FINANCIAL from './items/financial.menu'
import HOME from './items/home.menu'
import PHYSICAL_WORLD from './items/physical-world.menu'
import RECIPIENTS from './items/recipients.menu'
import RECURRENCE from './items/recurrence.menu'
import SALES from './items/sales.menu'
import SETTINGS from './items/settings.menu'
import TEAM from './items/team.menu'
import WEBHOOKS from './items/webhooks.menu'

/**
 * @example
 *  [KEY]: {
 *    key: "String", // nome do contexto exemplo: sales
      label: 'String', // label para tradução, exemplo: sidebar.sales
      routeName: "String", // nome da rota que irá redirecionar, usado em casos de nao ter submenus - (opcional)
      showSection: Boolean, // condicional de permissão para exibir item no menu
      icon: String, // nome ícone Uni icons - (opcional)
      beta: Boolean, // se item leva badge Beta - (opcional)
      items: { usado para submenus, porem nao pode ter a propriedade routeName - (opcional)
        [KEY]: {
          label: String, // label para tradução
          showItem: Boolean, // condicional de permissão para exibir item
          active: Boolean // se item está selecionado, exemplo: routeName === 'orders' || routeName === 'ordersDetail'
        }
      }
    }
 * @param {Object} args
 * @returns List<Object>
 */
const SIDEBAR = args =>
  [
    HOME,
    SALES,
    FINANCIAL,
    RECURRENCE,
    RECIPIENTS,
    CUSTOMERS,
    WEBHOOKS,
    TEAM,
    PHYSICAL_WORLD,
    SETTINGS
  ].map(item => item(args))

export default SIDEBAR
